<template>
  <div id="app" v-if="!loading">
    <div class="head">
      <div class="biaoti">
        <!-- <div
          class="router-link"
          :class="routerName === '园区推介' ? 'router-link-change' : ''"
        >
          <router-link to="/show"> 园区推介</router-link>
        </div> -->
        <div
          class="router-link"
          :class="routerName === '招商引资' ? 'router-link-change' : ''"
        >
          <router-link to="/industryChain"> 招商引资</router-link>
        </div>
        <div
          class="router-link"
          :class="routerName === '利通经济' ? 'router-link-change' : ''"
        >
          <router-link to="/"> 利通经济</router-link>
        </div>

        <div
          class="router-link"
          :class="routerName === '玩转利通' ? 'router-link-change' : ''"
        >
          <router-link to="/mapIndex"> 玩转利通</router-link>
        </div>
        <!-- <div
            class="router-link"
            :class="routerName === '居民数据' ? 'router-link-change' : ''"
        >
          <router-link to="/dataIndex">居民数据</router-link>
        </div> -->
      </div>
    </div>
    <div class="app-mine">
      <router-view />
    </div>
  </div>
</template>

<script>
import { getInfo } from "../api/login";
export default {
  name: "App",
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    routerName() {
      return this.$route.name;
    },
  },
  created() {
    let whei = window.innerWidth;
    console.log(whei);
    let html = document.getElementById("html");
    html.style.fontSize = whei / 20 + "px";
    window.addEventListener("resize", () => {
      whei = window.innerWidth;
      html.style.fontSize = whei / 20 + "px";
    });
  },
  mounted() {
    // this.getUserInfo();
  },

  methods: {
    getUserInfo() {
      this.loading = true;
      getInfo().then((v) => {
        if (v.code === 200) {
          this.loading = false;
        } else {
          this.$message.error(v.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss">
* {
  list-style: none;
  padding: 0;
  margin: 0;
  text-decoration: none;
}
html,
body {
  height: 100%;
}
#app {
  height: 100%;
  background: url("../assets/images/bg.png") no-repeat;

  background-size: 100% 100%;
  .head {
    height: 0.65rem;
    background: url("../assets/images/head_bg.png") no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    .biaoti {
      display: flex;
      position: absolute;
      left: calc(50% - 3rem);
      top: 0.15rem;
      width: 6rem;
      justify-content: space-between;
      font-size: 0.2rem;
      font-weight: bold;
      .router-link > a {
        color: #399dfe;
        &:hover {
          color: #087ffd;
        }
      }
      .router-link-change > a {
        color: #fff !important;
      }
    }
  }
  .app-mine {
    height: calc(100% - 0.65rem);
  }
}
</style>
